import { SVGProps } from 'react';

export const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17'
    height='17'
    viewBox='0 0 17 17'
    fill='none'
    {...props}>
    <g opacity='0.7'>
      <path
        d='M5 2.5V4M12 2.5V4M2.5 13V5.5C2.5 4.67157 3.17157 4 4 4H13C13.8284 4 14.5 4.67157 14.5 5.5V13M2.5 13C2.5 13.8284 3.17157 14.5 4 14.5H13C13.8284 14.5 14.5 13.8284 14.5 13M2.5 13V8C2.5 7.17157 3.17157 6.5 4 6.5H13C13.8284 6.5 14.5 7.17157 14.5 8V13'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);
